<template>
  <v-card class="mb-8">
    <v-card-title>この端末の印刷設定</v-card-title>
    <v-card-text>
      <v-switch
        v-model="useReceiptPrinterOnThisDevice"
        label="この端末で印刷を使用する"
        inset
        dense
        hide-details
        class="mt-0"
      />
      <div class="text-caption text--secondary mt-1 ml-2">
        OFFにするとこの端末からは印刷されません。<br>
        印刷を使わない端末を OFF にすると、プリンタ全体の応答が安定します（複数端末が同時にプリンタへ接続して詰まる現象を防げます）。<br>
        この設定はこの端末にのみ保存されます。
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api'
import useReceiptPrinterDeviceSetting from '@/views/composable/useReceiptPrinterDeviceSetting'

export default defineComponent({
  setup() {
    // 端末ごとの「プリンタを使う/使わない」設定 (デフォルト: 使う)
    // CashRegisterMenu / Club.vue と同じ module-singleton ref を共有するため表示が自動整合する
    const { isDisabled, setDisabled } = useReceiptPrinterDeviceSetting()
    const useReceiptPrinterOnThisDevice = computed({
      get: () => !isDisabled.value,
      set: value => { setDisabled(!value) },
    })

    return { useReceiptPrinterOnThisDevice }
  },
})
</script>
